import { LocalDate } from "@js-joda/core";
import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { DatePicker } from "components/designV2/datePicker/datePicker";
import { Modal } from "components/designV2/modal/modal";
import { useTranslation } from "react-i18next";
import { Message } from "../../layout/profilePanel.styled";

interface ProfilePanelEndEmploymentModalProps {
  isOpen: boolean;
  isSaving: boolean;
  endEmploymentDate: LocalDate | null;
  employmentStartDate: LocalDate | null;
  title: string;
  body: string;
  onClose: () => void;
  onConfirm: () => void;
  onEndEmploymentDateChange: (date: LocalDate | null) => void;
}

/**
 * Handles profile panel end employment modal.
 */
export const ProfilePanelEndEmploymentModal = (
  props: ProfilePanelEndEmploymentModalProps,
): JSX.Element => {
  const { t } = useTranslation();
  const isEndDateBeforeStartDate =
    props.endEmploymentDate != null &&
    props.employmentStartDate != null &&
    props.endEmploymentDate.isBefore(props.employmentStartDate);

  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      size="compact"
      variant="default"
      showCloseButton={false}
      centerText
      label={props.title}
      footer={
        <>
          <SecondaryButton
            label={t("General.Cancel")}
            onClick={props.onClose}
            disabled={props.isSaving}
          />
          <PrimaryButton
            label={t("General.Save")}
            onClick={props.onConfirm}
            disabled={
              props.isSaving ||
              props.endEmploymentDate == null ||
              isEndDateBeforeStartDate
            }
          />
        </>
      }
    >
      <Message>{props.body}</Message>
      <DatePicker
        label={t("Staff.AddStaffPanelFieldEndDate")}
        value={props.endEmploymentDate}
        allowClear={false}
        onChange={props.onEndEmploymentDateChange}
      />
    </Modal>
  );
};
